query UserApprovalHistorySearchHints(
  $searchRequest: SearchRequestInput!
  $isQueuedSearch: Boolean
  $isHistorySearch: Boolean
  $isLinkSearch: Boolean
) {
  userApprovalSearchHints(
    searchRequest: $searchRequest
    isQueuedSearch: $isQueuedSearch
    isHistorySearch: $isHistorySearch
    isLinkSearch: $isLinkSearch
  ) {
    nodes {
      id
      caption
      resultsCount
    }
  }
}
